import React, { useState } from 'react';

import { ICustomDescriptionProps } from 'common/components/FieldGenerator/types';
import { FieldsType } from 'common/types/fields';

import styles from './styles.module.scss';
import { useTranslateFn } from '../../../../../utils/useTranslateFn';
import Popup from '../../../../containers/components/CardNav/components/Popup';

const HoseProductDescription = ({
  field,
}: ICustomDescriptionProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const toggle = () => setOpen((o) => !o);
  const t = useTranslateFn<string>();
  if (field.type === FieldsType.dropdown) {
    const selection = field.value?.selected?.[0];
    if (selection) {
      const descriptionItems: string[] = [];
      const attrs = selection.attributes as Record<string, string>;
      if (attrs?.description) {
        descriptionItems.push(attrs?.description);
      }
      if (attrs?.abrasion_resistance) {
        descriptionItems.push(`Abrasion Resistance: ${attrs?.abrasion_resistance}`);
      }
      if (attrs?.construction) {
        descriptionItems.push(`Construction: ${attrs?.construction}`);
      }
      if (attrs?.impulse_cycle) {
        descriptionItems.push(`Impulse Cycle: ${attrs?.impulse_cycle}`);
      }
      return (
        <div className={styles.content}>
          {!open ? (
            <button type="button" onClick={toggle}>
              {t('texts.btn.showHoseDetails')}
            </button>
          ) : (
            <button type="button" onClick={toggle}>
              {t('texts.btn.hideFittingDetails')}
            </button>
          )}
          <Popup
            open={open}
            onClose={toggle}
            isWideImage
            item={{
              title: selection.title,
              image: selection.attributes?.image || '',
              category: attrs?.category || '',
              description: <span>{descriptionItems.map((item) => <p key={item}>{item}</p>)}</span>,
            }}
          />
        </div>

      );
    }
  }
  return null;
};
export default HoseProductDescription;
